module.exports = __webpack_public_path__ + "3f5fef64b9bb3ef6ded20c917f3082f7.ttf";